import { SidebarMenuButton, SidebarMenuItem, useSidebar } from '@features/ui';
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { cn } from '@lib/utils';

import { BaseNavItem } from './types';

type Props = {
  item: BaseNavItem;
};

export const NavItem: React.FC<Props> = ({ item }) => {
  const { setOpenMobile } = useSidebar();
  const { t } = useTranslation();
  const location = useLocation();

  const isActive = checkIsActive(location.pathname, item.url);

  return (
    <SidebarMenuItem>
      <div className="flex gap-x-5 pr-2 md:pr-0">
        <div
          className={cn(
            'w-1 rounded-tr-[4px] rounded-br-[4px]',
            isActive ? 'bg-primary' : 'bg-transparent'
          )}
        />
        <SidebarMenuButton
          asChild
          className="w-48 h-[50px] gap-x-[18px]"
          tooltip={item.title}
          variant={isActive ? 'gradient' : 'default'}
        >
          <Link to={item.url} onClick={() => setOpenMobile(false)}>
            {item.icon && <item.icon />}
            <span>{t(item.title)}</span>
          </Link>
        </SidebarMenuButton>
      </div>
    </SidebarMenuItem>
  );
};

function checkIsActive(href: string, url: string) {
  if (url === '/') {
    return href.split('?')[0] === url;
  }

  return href.includes(url) || href.split('?')[0] === url;
}
